/**
 * THE SITE'S TAGLINE (Miles, 2026-11-02: "the auth page needs to come into alignment with the hero section, same with
 * footer section tagline"): one copy of the home page hero's headline, read by the hero itself
 * (src/design/pavilion/pages/home/homeContent.ts), the sign-in and create-account page's heading beside the card
 * (src/components/auth/signInWords.ts, both designs) and both footers (src/design/pavilion/shell/PavilionFooter.tsx,
 * src/components/GlobalFooter.tsx). It replaced "24/7 AI employees for law and finance" everywhere it stood.
 *
 * Plain strings and no imports: the footers ride the first download, so this module costs a few bytes there and pulls
 * nothing in. The site's lowercase voice. The fields are written as the guest knowledge's extractor reads them
 * (scripts/lib/public-copy.mjs: `title:` and `lead:`, a string on the field's own line), so the signed-out Prest0n
 * reads the tagline too (scripts/generate-guest-knowledge-source.mjs lists this file for "/").
 */
export const SITE_TAGLINE_WORDS = {
  title: 'more expert capacity. without more headcount.',
  lead: 'Prest0n does anything an employee with a computer can do, out of the box.',
} as const;

/** The tagline: the hero's h1, the auth page's heading and the footers' line. */
export const SITE_TAGLINE: string = SITE_TAGLINE_WORDS.title;

/** The line under it on the hero (and the auth page's, where it shows one). */
export const SITE_TAGLINE_LEAD: string = SITE_TAGLINE_WORDS.lead;
